module.exports = __webpack_public_path__ + "img/editors-active.6f10b40a.svg";